import { ToastContainer } from 'react-toastify';
import React from 'react';
import 'react-toastify/dist/ReactToastify.css';

const ReactToast = () => {
  return <ToastContainer position="top-center" />;
};

export default ReactToast;
